// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/dist/cjs.js!../../../../../node_modules/vue-loader/dist/stylePostLoader.js!../../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-1.use[2]!../../../../../node_modules/sass-loader/dist/cjs.js!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CustomerForm.vue?vue&type=style&index=1&id=e7c9d4f8&lang=scss");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("299de2a6", content, true, {});